module.exports = __webpack_public_path__ + "static/img/weixiao.aa770beb.png";